define('helpers/web-helpers',[
    "evertrue",
    "jquery",
    "underscore",
    "backbone",
    "moment",
    "views/components/FormView",
    "ViewManager",
    "views/navigation/NavigationView",
    "views/errors/AlertView",
    "models/UserModel",
    "collections/PersonCollection",
    "models/dna/DnaModel",
    "classnames",
    "dust"
], function WebHelperFactory (
    EverTrue, $, _,
    Backbone,
    moment,
    FormView,
    ViewManager,
    NavigationView,
    AlertView,
    UserModel,
    PersonCollection,
    DnaModel,
    classNames ) {

    EverTrue.setup = function() {
        EverTrue.User = new UserModel();
        EverTrue.User.retrieve();
        EverTrue.Directory = new PersonCollection();
        EverTrue.classSet = classNames;
        EverTrue.searches = {};

        // initialize Navigation and ViewManager
        if (!EverTrue.NavigationView) {
            EverTrue.NavigationView = new NavigationView();
        }
        if (!EverTrue.ViewManager) {
            EverTrue.ViewManager = new ViewManager();
        }

        // Expand BackBone Events
        EverTrue.BackboneReactEvents = {
            componentWillUnmount: function() {
                return this.stopListening();
            }
        };
        _.extend(EverTrue.BackboneReactEvents, Backbone.Events);

        // initialize Application DNA - dont pull from local storage as we always want
        // this to be the most recent, and dont want to risk poluting DNA from different
        // organizations
        EverTrue.DNA = new DnaModel();

        // Kick off Global Event Listeners
        EverTrue.alertView = new AlertView();
        EverTrue.vent.on("apiError", function(options, xhr, textStatus, errorThrown) {
            EverTrue.alertView.globalErrorCallback(options, xhr, textStatus, errorThrown);
        });

    };

    EverTrue.erase = function() {
        // clear out both user and session just to make sure
        EverTrue.User.clear();
        EverTrue.Session.clear();
        EverTrue.Organization.clear();
        EverTrue.DNA.clear();

        EverTrue.ViewManager.clear();

        // clear all keys except login page related keys
        EverTrue.clearStorage(['has_admin_login']);

        // Clear the profile cache because it might have connected data
        EverTrue.Directory.reset();
        EverTrue.amplify('directory', null);

        Raven.setUser({});

        EverTrue.vent.unbind();
    };

    // handle template management
    EverTrue.fetchTemplate = function(templateName, done) {
        var cachedTmplName;
        // if we are developing locally we dont want templates to be cached
        if (!EverTrue.conf.developer){
            // do we have a compiled version of the template in dust's cache?
            cachedTmplName = (dust.cache[templateName]) ? templateName : null;
        }

        if (cachedTmplName){
            if ( _.isFunction(done) ) {
                done( cachedTmplName );
            }
        }
        else
        {
            var templatePath = window.EverTrue.conf.wwwBase + 'app/templates/';
            var path = templatePath + templateName;
            var localStorageKey = 'tmpl_' + templateName;
            var template;
            var compiled;

            // Fetch it asynchronously if not available from the dust cache
            //  we need to include the dust compiler
            require(['dustCompiler'], function() {
                // $.get(path, function(templateFromServer) {
                require(['text!'+path], function( templateFromServer ) {
                    compiled = dust.compile( templateFromServer, templateName );
                    dust.loadSource(compiled);
                    // if a template was found, call the callback
                    if ( _.isFunction(done) ) {
                        done( templateName );
                    }
                });
            });
        }
    };

    EverTrue.templateFilters = function() {
        var filters = {
            date: function(value) {
                return moment(value).format('YYYY-MM-DD');
            },
            time: function(value) {
                return moment(value).format('h:mm a');
            }
        };

        return filters;
    };

    EverTrue.templateHelpers = function() {
        var helpers = {
            keyvalue: function(chunk, context, bodies){
                var items = context.current(),
                    ctx;

                _.each(items, function(value, key){
                    ctx = {"key": key, "value": value};
                    chunk = chunk.render(bodies.block, context.push(ctx));
                });
                return chunk;
            },

            index: function(chunk, context) {
                var data = context.current();
                return chunk.write(data.$idx);
            },

            selected: function(chunk, context, bodies, params) {
                var data = context.current();
                if (data[params.selected] == params.val) {
                    return chunk.write('value="' + params.val + '" selected');
                } else {
                    return chunk.write('value="' + params.val + '"');
                }
            },

            activenav: function(chunk, context, bodies, params) {
                var data = context.current();
                if (data.active && data.active.match(params.path)) {
                    return chunk.write("active");
                } else {
                    return chunk.write(" ");
                }
            },

            navgroup: function(chunk, context, bodies, params) {
                var data = context.current(),
                    user_features = _.keys(data),
                    group_features = params.features.split(","),
                    showGroup = _.intersection(user_features, group_features);

                if (!_.isEmpty(showGroup)) {
                    chunk.render(bodies.block, context);
                    return chunk;
                } else {
                    return chunk.write(" ");
                }
            }
        };
        return helpers;
    };

    var helper = {};
    return helper;
});

